import React, { Component } from 'react';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import servicioArchivos from '../servicio/ServicioArchivos';
import servicioHttp from '../servicio/ServicioHttp';
import servicioObjetos from '../servicio/ServicioObjetos';

export class DescargaClienteSua extends Component {

    constructor(props) {
        super(props);
        this.state = {
            acepto: false
        };
        this.consultarAceptacionServiciosa();
    }

    consultarAceptacionServiciosa = () => {
        servicioHttp.consumirPostHttp('usuario/consultar_aceptacion.json').then(response => {
            console.log("response.data.mensaje: ",response.data.mensaje);
           let valor = servicioObjetos.esObjetoVacio(response.data.mensaje)?false:true;
           console.log("valor: ",valor);
           this.setState({acepto:valor});
        });
    }

    aceptacionTerminos = (e) => {
        let aceptacionDescargaCliente = e.checked ? 1 : 0;
        servicioHttp.consumirPostHttp('usuario/aceptacion_cliente.json', { aceptacionDescargaCliente: aceptacionDescargaCliente }).then(response => {
            if (!response.data.error) {
                this.setState({ acepto: e.checked });
            }
        });
    }

    descargaCliente = () => {
        servicioArchivos.descargaArchivo('/cliente/descarga.json', null, this);
    }

    render() {

        let { acepto } = this.state;

        return (
            <div>
                <div className="card card-w-title">
                    <h1>Descarga aplicativo de conexión SUA</h1>
                </div>
                <div className="card">
                    <div className="p-grid">
                        <div className="p-col-12 p-md-12">
                            <p>Aqui estan los terminos... solo acepta y ya vamos dale</p>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <center><Checkbox id="aceptacion" checked={acepto} onChange={this.aceptacionTerminos} />
                                <label htmlFor="aceptacion" className="p-checkbox-label">Estoy de acuerdo</label></center>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <center><Button disabled={!acepto} id="descargarCliente" label="Descargar" icon="pi-md-file-download" onClick={this.descargaCliente} /></center>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}